/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-07-02 16:57:31
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2022-06-29 17:05:24
 * @Content:
 */

import React, { useEffect, useMemo, useState } from "react";
import styles from "./index.style";
import Modal from "../../Common/Modal/Modal";
import { IPostCreateTempDetail } from "../../../service/Index";
import utils from "../../../utils/index";
import "./index.css";
import { AddressCard } from "./components/AddressCard";
import {
  ADDRESS_URL_PARAM_KEY,
  LOCAL_STORAGE_DEFAULT_ADDRESS_KEY,
} from "../../../constants/address";
import { useShowToast } from "../../../hooks/utilHooks";
import { actTimeState } from "../utils";
import { IActivityInfo } from "../../../service/activity/interface";
import { Toast } from "codoon-come";
import giftIcon from "../../../assets/imgs/icon_popup_gift@2x.png";
import { isInCodoon } from "../../../utils/bridge";
import { openCodoon } from "open-codoon";
import { tempBtnColorSelecor } from "../../../store/common/selector";
import { connect } from "react-redux";

const { GlobalToast } = Toast;

const PREFIX = "ActivityRewardModal";

const DEFAULT_REWARD_BG_IMG =
  "https://s1.codooncdn.com/operation-tools/internal-user/2026-08-28T17.07.47/750x250x185514xmaSVN80orgZ3tekdce.png";

type IProps = {
  visible: boolean;
  onClose: () => void;
  activityDetail: IActivityInfo;
  tempDetail: IPostCreateTempDetail;
} & ReturnType<typeof mapStateToProps>;

const RewardModalCore: React.FC<IProps> = React.memo(
  ({ visible, onClose, activityDetail, tempDetail, tempBtnColor }) => {
    const { toastVisible, toastTip, showToast } = useShowToast();

    /* 按钮颜色 */
    const tempBtnStyle = useMemo(() => {
      return {
        backgroundColor: tempBtnColor,
      };
    }, [tempBtnColor]);
    const tempBtnFontStyle = useMemo(() => {
      return {
        color: tempBtnColor,
      };
    }, [tempBtnColor]);

    /**
     * 跳转至地址选择页
     */
    const addAddress = React.useCallback(() => {
      // 若已能获取到地址，则可将地址置入localStorage作为address页面的默认表单值
      if (
        activityDetail.address_info &&
        !utils.isAddressEmpty(activityDetail.address_info)
      ) {
        window.localStorage.setItem(
          LOCAL_STORAGE_DEFAULT_ADDRESS_KEY,
          JSON.stringify(activityDetail.address_info)
        );
      }
      window.location.href = `/activity/club/address?${ADDRESS_URL_PARAM_KEY.ACTIVITY_ID}=${activityDetail.activity_id}&${ADDRESS_URL_PARAM_KEY.EMIT_ADDRESS}=1`;
    }, [activityDetail]);

    const jumpToMoneyPage = React.useCallback(() => {
      if (!isInCodoon()) {
        // 唤醒咕咚个并进入当前活动页
        openCodoon(window.location.origin + window.location.pathname, "h5");
      } else {
        // 跳转至我的红包页面
        window.location.href = "https://www.codoon.com/h5/cash/index.html";
      }
    }, []);

    /**
     * 渲染领奖区
     */
    const renderPrizeArea = React.useCallback(() => {
      const rewardType = tempDetail.reword_list.reward_type;

      // 活动已结束
      const isEnd = actTimeState(activityDetail) === 2;

      if (rewardType === "real") {
        /** 实物奖励 */
        const currAddress = activityDetail.address_info;
        return (
          <div>
            {(() => {
              if (currAddress && !utils.isAddressEmpty(currAddress)) {
                return (
                  <div>
                    <AddressCard
                      address={currAddress}
                      onEdit={addAddress}
                      isEnd={isEnd}
                    />
                  </div>
                );
              } else {
                // 活动已结束
                if (isEnd) {
                  return null;
                } else {
                  return (
                    <div
                      className={`${PREFIX}-btn`}
                      style={{ ...styles.addAddressBtn, ...tempBtnStyle }}
                      onClick={addAddress}
                    >
                      填写地址
                    </div>
                  );
                }
              }
            })()}
          </div>
        );
      } else if (rewardType === "virtual") {
        /** 虚拟奖励 */
        const coupon = activityDetail.coupon || "";
        return (
          <div>
            {activityDetail.redeem_reward_url && (
              <div
                style={styles.virtualGetBtn}
                onClick={() => {
                  utils.copyToClipboard(coupon);
                  showToast("兑换码已复制，可直接粘贴");
                  setTimeout(() => {
                    window.location.href =
                      activityDetail.redeem_reward_url || "";
                  }, 1000);
                }}
              >
                去领取奖励
              </div>
            )}
            <div style={styles.virtualReward}>
              <div style={styles.virtualRewardCoupon}>兑换码:{coupon}</div>
              <div
                style={{ ...styles.virtualRewardBtn, ...tempBtnFontStyle }}
                className={`${PREFIX}-btn`}
                onClick={() => {
                  utils.copyToClipboard(coupon);
                  showToast("兑换码已复制，可直接粘贴");
                }}
              >
                复制
              </div>
            </div>
          </div>
        );
      }
    }, [activityDetail, tempDetail, addAddress]);

    /**
     * 渲染商品促销类型的领奖区
     */
    const renderProPrizeArea = React.useCallback(() => {
      const rewardType = tempDetail.reword_list.reward_type;
      const rewardMsg = tempDetail.reword_list.reward_msg;
      const currAddress = activityDetail.address_info; // 地址

      return (
        <>
          <div style={styles.entityTitle}>恭喜您获得以下奖品</div>
          <div style={styles.entityItemFirst}>
            <div style={styles.entitylabel}>
              <img src={giftIcon} style={styles.entityIcon} />
              <div style={styles.entityDesc}>完成活动奖励</div>
            </div>
            <div style={styles.entityInfo}>
              <div style={styles.entityName}>
                {activityDetail?.user_goods_suit?.award_desc}
              </div>
              {activityDetail?.user_goods_suit?.award_type == 1 ? (
                <div
                  style={{ ...styles.entityBtn, ...tempBtnStyle }}
                  onClick={jumpToMoneyPage}
                >
                  去查看
                </div>
              ) : (
                ""
              )}
              {activityDetail?.user_goods_suit?.award_type == 2 ? (
                <div
                  style={{ ...styles.entityBtn, ...tempBtnStyle }}
                  onClick={addAddress}
                >
                  {currAddress && !utils.isAddressEmpty(currAddress)
                    ? "编辑地址"
                    : "填写地址"}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          {/* 有奖活动才显示 */}
          {activityDetail?.is_reward_activity ? (
            <div style={styles.entityItem}>
              <div style={styles.entitylabel}>
                <img src={giftIcon} style={styles.entityIcon} />
                {rewardType == "virtual" ? (
                  <div style={styles.entityDesc}>{rewardMsg}</div>
                ) : (
                  ""
                )}
                {rewardType == "sync_with_sign_page" ? (
                  <div style={styles.entityDesc}>幸运抽奖</div>
                ) : (
                  ""
                )}
                {rewardType == "real" ? (
                  <div style={styles.entityDesc}>实物奖励</div>
                ) : (
                  ""
                )}
              </div>

              {(rewardType == "virtual" || rewardType == "real") &&
              Number(activityDetail?.reward_count) > 0 ? (
                <div style={styles.entityFoComment}>
                  前{activityDetail.reward_count}名完成挑战的咚友可获得此奖励
                </div>
              ) : (
                ""
              )}

              {/* 虚拟奖 */}
              {rewardType == "virtual" && activityDetail.reward_status != 1 ? (
                <>
                  <div style={styles.virtualPromotion}>
                    <div style={styles.virtualPromotionCoupon}>
                      {activityDetail?.coupon}
                    </div>
                    <div
                      style={{
                        ...styles.virtualRewardBtn,
                        ...tempBtnFontStyle,
                      }}
                      className={`${PREFIX}-btn`}
                      onClick={() => {
                        utils.copyToClipboard(activityDetail?.coupon || "");
                        showToast("兑换码已复制，可直接粘贴");
                      }}
                    >
                      复制
                    </div>
                  </div>
                  {activityDetail.redeem_reward_url ? (
                    <div
                      style={{ ...styles.virtualPromotionBtn, ...tempBtnStyle }}
                      onClick={() => {
                        window.location.href =
                          activityDetail.redeem_reward_url || "";
                      }}
                    >
                      去兑换
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}

              {/* 实体奖 */}
              {rewardType == "real" && activityDetail.reward_status != 1 ? (
                <div style={styles.entityInfo}>
                  <div style={styles.entityName}>{rewardMsg}</div>
                  <div
                    style={{ ...styles.entityBtn, ...tempBtnStyle }}
                    onClick={addAddress}
                  >
                    {currAddress && !utils.isAddressEmpty(currAddress)
                      ? "编辑地址"
                      : "填写地址"}
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* 抽奖 */}
              {rewardType == "sync_with_sign_page" ? (
                <div style={styles.entityInfo}>
                  <div style={styles.entityName}>{rewardMsg}</div>
                  <div
                    style={{ ...styles.entityBtn, ...tempBtnStyle }}
                    onClick={() => {
                      window.location.href = activityDetail.lottery_url || "";
                    }}
                  >
                    去抽奖
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* 未获奖情况下 */}
              {activityDetail.reward_status === 1 &&
              Number(activityDetail?.reward_count) > 0 &&
              (rewardType == "virtual" || rewardType == "real") ? (
                <div style={styles.sentOuttProInfoWrapper}>
                  <div style={styles.sentOutProInfo}>限量奖品已发完</div>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </>
      );
    }, [activityDetail, tempDetail, addAddress]);

    return (
      <Modal
        visible={visible}
        animation="fade"
        style={styles.rewardModal}
        onClose={onClose}
      >
        {toastVisible && <GlobalToast text={toastTip} />}
        <div style={styles.closeBtn} onClick={onClose} />
        <div
          style={{
            ...styles.contentWrapper,
            paddingBottom: `28.5px`,
            backgroundImage: `url(${tempDetail.reword_list.reward_img || DEFAULT_REWARD_BG_IMG})`,
          }}
        >
          {/* type : 0 : 默认类型  1： 对赌  2： 商品促销 */}
          {activityDetail.type == 2 ? (
            renderProPrizeArea()
          ) : (
            <>
              <div style={styles.title}>恭喜您完成活动挑战</div>
              {activityDetail.reward_status === 1 ? (
                // 未获奖
                <div style={styles.sentOutInfoWrapper}>
                  <div style={styles.sentOutInfo}>限量奖品已发完</div>
                </div>
              ) : (
                // 获奖
                <>
                  <div style={styles.comment}>
                    {tempDetail.reword_list.reward_msg}
                  </div>
                  {renderPrizeArea()}
                </>
              )}

              {/* 除开商品促销 - 如果有限额，才显示（-1代表无限额） */}
              {activityDetail.reward_count &&
              activityDetail.reward_count !== -1 ? (
                <div style={styles.footerComment}>
                  前{activityDetail.reward_count}名完成活动用户可领取
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      </Modal>
    );
  }
);

const mapStateToProps = (state: any) => {
  return {
    tempBtnColor: tempBtnColorSelecor(state),
  };
};

export const RewardModal = connect(mapStateToProps)(RewardModalCore);
